import BaseModel from '../base/BaseModel.model';
export default class AprobationStatus extends BaseModel {

   public isApprove?: boolean;
   public document?: any;
   
   constructor(){
       super();
       this.init();
   }

    init(){
       this.isApprove = true;
       this.document = null;
    }

}